export const contentWrapperColSpan = {
  base: '1 / -1',
  m: '1 / -1',
  lg: '3 / -3',
} as const;

export const fullWidthColSpan = '1 / -1' as const;

export const mainContentProps = {
  colSpan: contentWrapperColSpan,
  colSpanFullWidth: fullWidthColSpan,
} as const;
